<template>
  <div class="c-container js-container">
    <div class="u-container">
      <div class="c-container__inner">
        <progressBar :step="step" />
        <!-- Begin content -->
        <!-- Begin content -->
        <h1 class="c-container__title">{{ json.title }}</h1>
        <!-- Page builder components -->
        <section
          v-for="(component, index) in json.components"
          :key="index"
          :class="component.type.toLowerCase()"
        >
          <component
            :is="component.type"
            :component="component"
          />
        </section>
        <!-- Selection of country -->
        <form>
          <p
            v-if="errors.length"
            class="c-step__warning"
          >
            <span>
              {{ errors[0] }}
            </span>
          </p>
          <label
            v-for="(countryOption, index) in json.countries"
            :key="index"
          >
            <input
              v-model="country"
              :value="countryOption.value"
              type="radio"
            >
            <span class="checkmark"></span>
            <strong>{{ countryOption.name }}: </strong>{{ countryOption.description }}
          </label>
        </form>
        <div class="c-container__button-container">
          <button
            class="c-container__button c-container__button--prev"
            type="submit"
            @click.stop.prevent="onSubmitPrevious"
          >
            Previous
          </button>
          <button
            class="c-container__button c-container__button--next"
            type="submit"
            @click.stop.prevent="onSubmitNext"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" src="@/assets/sass/components/step.scss"></style>

<script>
// Pym.js embed.
import pymChild from '../embed/index';

// Import all components.
import ProgressBar from '../components/ProgressBar.vue';
import ContentComponent from '../components/ContentComponent.vue';

// Import the json for this component.
const jsonConfig = require('../assets/content/selection.json');

export default {
  components: {

    // Make all components available, must be lowerCamel.
    contentComponent: ContentComponent,
    progressBar: ProgressBar,
  },
  data() {
    return {
      step: 2,

      // The JSON file as a JS array.
      json: jsonConfig,
      errors: [],
    };
  },
  computed: {

    // Setter and getter for country.
    country: {
      get() {
        return this.$store.getters.country || null;
      },
      set(value) {
        this.$store.commit('setCountry', value);
      },
    },
  },
  mounted: () => {
    pymChild.sendHeight();
  },
  updated: () => {
    pymChild.sendHeight();
  },
  methods: {
    onSubmitPrevious() {
      this.$router.push('/introduction');
    },
    onSubmitNext() {
      if (this.country !== null) {
        this.$store.commit('setStep', 1);
        this.$router.push(`/country/${this.$store.getters.country}/1`);
        this.scrollToTop();
      } else {
        this.errors.push('Please select a country.');
      }
    },
    scrollToTop() {
      document.getElementsByClassName('js-container')[0].scrollIntoView();
      pymChild.scrollParentToChildPos(-72);
    },
  },
};
</script>
